var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 84,
    viewBox: "0 0 243 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 29.498 36.4986)",
    fill: "#E3E0FB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 13.498 9.49859)",
    fill: "#E3E0FB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.498,
    cy: 37.4986,
    rx: 4.5,
    ry: 4.49859,
    fill: "#E3E0FB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.498,
    cy: 60.4986,
    rx: 4.5,
    ry: 4.49859,
    fill: "#E3E0FB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 50.498 14.4986)",
    fill: "#E3E0FB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 41.498 68.5025)",
    fill: "#E3E0FB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.498,
    cy: 15.4986,
    rx: 4.5,
    ry: 4.49859,
    fill: "#E3E0FB"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.5,
    cy: 62.4986,
    rx: 4.5,
    ry: 4.49859,
    fill: "#E3E0FB"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 4.5 51.4986)",
    fill: "#E3E0FB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 228.498,
    cy: 17.5,
    r: 4.5,
    fill: "#E3E0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7585 0.121833C87.2272 0.672566 82.8543 2.75749 79.4904 5.98321C75.9881 9.34662 73.772 13.8902 73.1981 18.8074C72.9211 21.1481 72.9409 45.9249 73.2179 48.3639C73.772 53.3598 76.186 58.2181 79.7675 61.5225C82.2013 63.7451 85.7234 65.6923 88.6717 66.4201L89.9974 66.7544L90.0568 73.9927C90.0568 73.9927 90.0132 80.0514 90.7097 82.0963C91.4062 84.1412 94.2516 84.3976 95.9335 83.5321C96.3095 83.3355 107.464 73.2272 107.464 73.2272L114.427 67.1085H133.964C146.331 67.1085 147.143 67.0888 149.022 66.7151C158.045 64.8859 164.753 57.5493 165.782 48.3639C166.059 45.9249 166.079 21.1481 165.802 18.8074C165.01 12.0019 161.191 6.21924 155.216 2.73782C153.732 1.87238 151.337 0.928255 149.418 0.456198C147.697 0.0431476 147.558 0.0431492 120.39 0.00381112C105.372 -0.0158579 92.4906 0.0431565 91.7585 0.121833Z",
    fill: "#E3E0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.169 13.04C116.832 13.4034 115.814 14.3944 115.193 15.9304C114.907 16.6901 114.922 17.7472 115.352 25.097C115.543 28.4498 115.798 32.7771 115.909 34.693C116.148 38.8882 116.307 39.3341 117.739 40.0773C118.726 40.6059 119.41 40.6554 120.269 40.2755C121.638 39.6809 122.37 38.3266 122.37 36.4272C122.354 35.9152 122.592 31.3237 122.879 26.2201C123.452 15.9965 123.452 16.079 122.513 14.6751C121.622 13.3208 119.76 12.6271 118.169 13.04Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.047 44.1467C116.093 44.7666 114.866 46.4993 115.012 48.4068C115.189 50.6958 116.869 52.2536 119.161 52.2695C120.808 52.2695 122.165 51.4429 122.924 49.9805C123.343 49.1857 123.392 47.3895 123.02 46.5311C122.665 45.7363 121.826 44.8302 121.05 44.4487C120.34 44.099 118.709 43.9241 118.047 44.1467Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamationMark.ee6a0431ddb747f684e5c8cf75071f66.svg";
export { ForwardRef as ReactComponent };